/* eslint-disable */

import axios from 'axios'
import ChartFn from '@/common/chart-functions'
import dcChartFn from '@/common/dc-chart-functions'

export default {
    auditLog: async function (menusyspk, menuid, menuname, vizunit, action, response,deviceType) {
        await axios.post('/api/audit-log', {
                menuSyspk: menusyspk,
                menuId: menuid,
                menuName: menuname,
                // subMenuName: submenu,
                vizTitle: vizunit,
                action: action,
                response: response,
                deviceType:deviceType
            }
        )
    },

    renderChart: (vizType, chart, divId, vizfn) => {
        let fn = ChartFn[vizfn]
        if (!fn) {
            console.error('could not find function with name', vizfn)
            return
        }
        fn(chart, divId, vizType)
    },

    renderChartCompare: async (vizType, chart, divId, vizfn,resData,paramName,checkbox, gridflag,showValuesFlag,resetfilter) => {
        let fn = (await ChartFn[vizfn]()).default
        if (!fn) {
            console.error('could not find function with name', vizfn)
            return
        }
        fn(chart, divId,vizType, resData,paramName,checkbox, gridflag,showValuesFlag,resetfilter)
    },

    crossfilterDatafetch: (dataSqlId, viztypeClassName, x) => {
        let url = '/api/fetchDataWithParam/' + dataSqlId + '/' + viztypeClassName

        return axios.post(url, {})
            .then(res => {
                    let allSummaryData = res.data
                console.log("x from crossfilterdatafecth",x);
                    if (x) {
                        Object.keys(x).forEach(key => {
                            console.log('passed filter key,value', key, x[key]);

                            if (x[key] !== 'All' && x[key] !== null && x[key] !== undefined && x[key] !== '' && !(Array.isArray(x[key]) && x[key].length === 0)) {
                                allSummaryData = allSummaryData.filter(a => a[key] === x[key]);
                            }
                        });
                    }
                    dcChartFn['assignCrossfilterData'](allSummaryData)
                    return allSummaryData
                },
                err => {
                    console.error('error in fetching home summary data', err)
                })

    },
    renderDcChart: async (vizType, chart, divId, vizfn, data) => {
        let fn = dcChartFn[vizfn]
        if (!fn) {
            console.error('could not find function with name', vizfn)
            return
        }

        await fn(chart, divId, data)

    }
}
